import { apiClient, extractList } from './client';
import type {
  MilitaryRankModel,
  PlayerRankResponse,
  RankForScoreResponse,
} from '@/types/ranks';

const RANK_BASE = '/api/v1/MilitaryRank';
const PLAYER_UNIVERSE_BASE = '/api/v1/PlayerUniverse';

/** Catalogue complet des 12 grades (utilise pour resolution cote client). */
export async function fetchAllRanks(): Promise<MilitaryRankModel[]> {
  const { data } = await apiClient.get(`${RANK_BASE}`, { params: { pageSize: 50 } });
  const list = extractList<MilitaryRankModel>(data);
  return [...list].sort((a, b) => a.minCombatScore - b.minCombatScore);
}

/** Resout le grade pour un score donne (1 appel reseau). */
export async function fetchRankForScore(combatScore: number): Promise<RankForScoreResponse> {
  const { data } = await apiClient.get<RankForScoreResponse>(
    `${RANK_BASE}/for-score`,
    { params: { combatScore } },
  );
  return data;
}

/** Resout le grade actuel d'un PlayerUniverse (lit son PointBattle backend). */
export async function fetchPlayerRank(playerUniverseId: number): Promise<PlayerRankResponse> {
  const { data } = await apiClient.get<PlayerRankResponse>(
    `${PLAYER_UNIVERSE_BASE}/${playerUniverseId}/rank`,
  );
  return data;
}
